import initImage from './init-det.jpg';

// The landing: one real specimen, full-bleed, so the first impression is the
// art itself — never the raw full-set render. "Begin" drops into the live
// generator (which starts from the whole Mandelbrot set to explore from).
const IntroPanel = ({ onBegin }) => {
    return (
        <div id="hero">
            <img src={initImage} alt="A deep zoom into the Mandelbrot set" className="hero-image" />
            <div className="hero-scrim" />
            <div className="hero-content">
                <p className="hero-eyebrow">Mandelbrot set · infinite detail</p>
                <h1 className="hero-title">Find the one that&rsquo;s yours.</h1>
                <p className="hero-sub">Zoom into the infinite. Claim the coordinate no one else can.</p>
                <button type="button" className="btn-begin" onClick={onBegin}>Begin</button>
            </div>
        </div>
    );
};

export default IntroPanel;
